import qs from 'qs'

export default {
  createSearchedItemObject(item, itemParams) {
    // display: false のSKU(非表示)は無視したいため、絞り込み
    const targetItemSkus = item.itemSkus.filter(
      itemSku => itemSku.itemSkuSalesCondition.display
    )

    const prices = targetItemSkus
      .filter(itemSku => itemSku.itemSkuAccountingCondition != null)
      .map(itemSku => {
        return (
          itemSku.itemSkuAccountingCondition.price +
          itemSku.itemSkuAccountingCondition.shippingCost
        )
      })
    const minPrice = prices.sort((first, second) => {
      return first - second
    })[0]

    const isIncludeTax = targetItemSkus
      .filter(itemSku => itemSku.itemSkuDetail != null)
      .some(itemSku => itemSku.itemSkuDetail.displayTaxType == 1)

    const paramsString = qs.stringify(itemParams, { arrayFormat: 'brackets' })

    const soldOut = targetItemSkus.every(
      itemSku => itemSku.itemSkuSalesCondition.soldOut
    )

    return {
      id: item.id,
      linkUrl: `/bulk_order/items/${item.id}?${paramsString}`,
      imageUrl: item.itemImage.imageUrl,
      brandName: item.brand.name,
      itemName: item.name,
      itemPrice: minPrice.toLocaleString(),
      isIncludingTax: isIncludeTax,
      hasMultipleItemSkus: targetItemSkus.length > 1,
      soldOut: soldOut
    }
  }
}
